// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"272":"f8d5371b","279":"471d3c51","454":"73323609","467":"471d3c51","515":"471d3c51","565":"471d3c51","679":"7bb6cb40"}[chunkId] + ".chunk.css";
};